// Country name to ISO 3166-1 alpha-2 code mapping for flag images
export const countryCodeMap: Record<string, string> = {
  'Albania': 'al',
  'Algeria': 'dz',
  'Andorra': 'ad',
  'Angola': 'ao',
  'Argentina': 'ar',
  'Armenia': 'am',
  'Australia': 'au',
  'Austria': 'at',
  'Azerbaijan': 'az',
  'Bahrain': 'bh',
  'Bangladesh': 'bd',
  'Belarus': 'by',
  'Belgium': 'be',
  'Benin': 'bj',
  'Bolivia': 'bo',
  'Bosnia': 'ba',
  'Bosnia and Herzegovina': 'ba',
  'Bosnian': 'ba',
  'Brazil': 'br',
  'Bulgaria': 'bg',
  'Burkina Faso': 'bf',
  'Burundi': 'bi',
  'Cameroon': 'cm',
  'Canada': 'ca',
  'Canadian': 'ca',
  'Cape Verde': 'cv',
  'Cape Verdean': 'cv',
  'Central African Republic': 'cf',
  'Chad': 'td',
  'Chile': 'cl',
  'China': 'cn',
  'Colombia': 'co',
  'Comoros': 'km',
  'Congo': 'cg',
  'Costa Rica': 'cr',
  'Croatia': 'hr',
  'Cuba': 'cu',
  'Cyprus': 'cy',
  'Czech Republic': 'cz',
  'Czechia': 'cz',
  'Denmark': 'dk',
  'Dominican Republic': 'do',
  'DR Congo': 'cd',
  'DRC': 'cd',
  'Ecuador': 'ec',
  'Egypt': 'eg',
  'El Salvador': 'sv',
  'England': 'gb-eng',
  'English': 'gb-eng',
  'Equatorial Guinea': 'gq',
  'Eritrea': 'er',
  'Estonia': 'ee',
  'Ethiopia': 'et',
  'Faroe Islands': 'fo',
  'Finland': 'fi',
  'France': 'fr',
  'French': 'fr',
  'Gabon': 'ga',
  'Gambia': 'gm',
  'Georgia': 'ge',
  'Germany': 'de',
  'German': 'de',
  'Ghana': 'gh',
  'Gibraltar': 'gi',
  'Greece': 'gr',
  'Greek': 'gr',
  'Guatemala': 'gt',
  'Guinea': 'gn',
  'Guinea-Bissau': 'gw',
  'Haiti': 'ht',
  'Honduras': 'hn',
  'Hungary': 'hu',
  'Iceland': 'is',
  'Icelandic': 'is',
  'India': 'in',
  'Indonesia': 'id',
  'Iran': 'ir',
  'Iraq': 'iq',
  'Ireland': 'ie',
  'Irish': 'ie',
  'Israel': 'il',
  'Italy': 'it',
  'Italian': 'it',
  'Ivory Coast': 'ci',
  'Cote d\'Ivoire': 'ci',
  'Jamaica': 'jm',
  'Japan': 'jp',
  'Japanese': 'jp',
  'Jordan': 'jo',
  'Kazakhstan': 'kz',
  'Kenya': 'ke',
  'Kosovo': 'xk',
  'Kuwait': 'kw',
  'Kyrgyzstan': 'kg',
  'Latvia': 'lv',
  'Latvian': 'lv',
  'Lebanon': 'lb',
  'Liberia': 'lr',
  'Libya': 'ly',
  'Liechtenstein': 'li',
  'Lithuania': 'lt',
  'Luxembourg': 'lu',
  'Madagascar': 'mg',
  'Malawi': 'mw',
  'Malaysia': 'my',
  'Mali': 'ml',
  'Malta': 'mt',
  'Mauritania': 'mr',
  'Mauritius': 'mu',
  'Mexico': 'mx',
  'Moldova': 'md',
  'Monaco': 'mc',
  'Montenegro': 'me',
  'Morocco': 'ma',
  'Mozambique': 'mz',
  'Namibia': 'na',
  'Netherlands': 'nl',
  'Dutch': 'nl',
  'New Zealand': 'nz',
  'Nicaragua': 'ni',
  'Niger': 'ne',
  'Nigeria': 'ng',
  'Nigerian': 'ng',
  'North Korea': 'kp',
  'North Macedonia': 'mk',
  'North Macedonian': 'mk',
  'Northern Ireland': 'gb-nir',
  'Norway': 'no',
  'Norwegian': 'no',
  'Oman': 'om',
  'Pakistan': 'pk',
  'Palestine': 'ps',
  'Panama': 'pa',
  'Paraguay': 'py',
  'Peru': 'pe',
  'Philippines': 'ph',
  'Poland': 'pl',
  'Polish': 'pl',
  'Portugal': 'pt',
  'Portuguese': 'pt',
  'Qatar': 'qa',
  'Republic of Ireland': 'ie',
  'Romania': 'ro',
  'Romanian': 'ro',
  'Russia': 'ru',
  'Russian': 'ru',
  'Rwanda': 'rw',
  'San Marino': 'sm',
  'Saudi Arabia': 'sa',
  'Scotland': 'gb-sct',
  'Scottish': 'gb-sct',
  'Senegal': 'sn',
  'Serbia': 'rs',
  'Serbian': 'rs',
  'Sierra Leone': 'sl',
  'Singapore': 'sg',
  'Slovakia': 'sk',
  'Slovakian': 'sk',
  'Slovenia': 'si',
  'Slovenian': 'si',
  'Somalia': 'so',
  'South Africa': 'za',
  'South Korea': 'kr',
  'South Sudan': 'ss',
  'Spain': 'es',
  'Spanish': 'es',
  'Sri Lanka': 'lk',
  'Sudan': 'sd',
  'Suriname': 'sr',
  'Sweden': 'se',
  'Swedish': 'se',
  'Switzerland': 'ch',
  'Swiss': 'ch',
  'Syria': 'sy',
  'Taiwan': 'tw',
  'Tajikistan': 'tj',
  'Tanzania': 'tz',
  'Thailand': 'th',
  'Togo': 'tg',
  'Trinidad and Tobago': 'tt',
  'Tunisia': 'tn',
  'Turkey': 'tr',
  'Turkish': 'tr',
  'Turkmenistan': 'tm',
  'Uganda': 'ug',
  'Ukraine': 'ua',
  'Ukrainian': 'ua',
  'United Arab Emirates': 'ae',
  'UAE': 'ae',
  'United Kingdom': 'gb',
  'UK': 'gb',
  'United States': 'us',
  'USA': 'us',
  'American': 'us',
  'Uruguay': 'uy',
  'Uzbekistan': 'uz',
  'Venezuela': 've',
  'Vietnam': 'vn',
  'Wales': 'gb-wls',
  'Welsh': 'gb-wls',
  'Yemen': 'ye',
  'Zambia': 'zm',
  'Zimbabwe': 'zw',
};

export const getCountryFlagUrl = (country: string): string => {
  // Try exact match first
  let code = countryCodeMap[country];
  
  // If not found, try case-insensitive search
  if (!code) {
    const lowerCountry = country.toLowerCase();
    for (const [key, value] of Object.entries(countryCodeMap)) {
      if (key.toLowerCase() === lowerCountry) {
        code = value;
        break;
      }
    }
  }
  
  return `https://flagcdn.com/w40/${code || 'un'}.png`;
};